import React, {Component} from 'react';

/**
 * Slice 2k — the marker for free text the server withheld (finding #23).
 *
 * PLAIN, WITH NO REASON, and that is a decision rather than an omission. "Redacted — confidential
 * schema" would disclose the classification of an object the viewer is not allowed to see, which is
 * a smaller version of the oracle this whole access phase has been closing. The permission code
 * never reaches user-facing copy either.
 *
 * Renders NOTHING when there is nothing withheld, so every call site can drop it in unconditionally
 * beside the field it qualifies. The backend omits `redactedFields` entirely rather than sending an
 * empty array, which is what makes `{...}` the whole test here.
 */
class RedactedChip extends Component {
  render() {
    const {fields, field} = this.props;
    if (!fields || !fields.length) return null;
    // When a call site names one field, the chip only shows if THAT field was withheld — a row can
    // lose its description while keeping its definition, and one chip for the whole row would
    // misreport which content is missing.
    if (field && !fields.includes(field)) return null;

    return (
      <span
        className="status-chip redacted-chip"
        data-testid={this.props['data-testid'] || 'redacted-chip'}
        title="Hidden — you do not have access to this content"
      >
        Redacted
      </span>
    );
  }
}

export default RedactedChip;
